import React from 'react'
import AqBoolean from './QuestionTypes/AqBoolean';
import AqComment from './QuestionTypes/AqComment';
import AqChoice from './QuestionTypes/AqChoice';
import AqMatrix from './QuestionTypes/AqMatrix';
import AqChoiceWithLegend from './QuestionTypes/AqChoiceWithLegend';
import SurveyTitle from './SurveyTitle';





export default function AnalyticsQuestion({question,data:{singleResult, nestedResult}}) {

    const BooleanType = "boolean";
    const CommentType = "comment";
    const DropDownType = "dropdown";
    const MatrixType = "matrix";
    const RadioGroupType = "radiogroup";



    switch (question.type) {
        case(BooleanType):
            return <AqBoolean question={question} data={singleResult[question.name]}/>
        case(CommentType):
            return <AqComment question={question}  data={singleResult[question.name]}/>
        case(DropDownType):
            return <AqChoice question={question}  data={singleResult[question.name]}/>
        case(MatrixType):
            return <AqMatrix question={question}  data={nestedResult[question.name]}/>
        case(RadioGroupType):
            return <AqChoice question={question} data={singleResult[question.name]}/>
        default:
            return null;
    }

}
